/**
 * 工单绩效权重统计组件
 */

import { useEffect, useState } from 'react';
import { Row, Col, message, DatePicker, } from 'antd';
import { Chart } from '@antv/g2';
import $ from 'jquery';
import {
    isGTscreenWidth,
    UjoinParams,
    AddRequestHeaders,
    LastMonth,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

/** 
* 日期样式
*/
import locale from 'antd/es/date-picker/locale/zh_CN';
const { RangePicker } = DatePicker;

const WOWDCD = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);

    const [startDate, setStartDate] = useState(LastMonth() + '-01');
    const [endDate, setEndDate] = useState(LastMonth() + '-31');

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh) {
                // 获取数据
                const params = {
                    'start_date': startDate,
                    'end_date': endDate,
                }
                $.ajax({
                    url: `${CNF.api}reports/wo/wdcd${UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            // 重新封装数据
                            let newData = [];
                            for (let i = 0; i < data.dat.length; i++) {
                                let item = data.dat[i];
                                let item1 = {
                                    douser: item.douser,
                                    type: '工单数量',
                                    count: item.count,
                                }
                                let item2 = {
                                    douser: item.douser,
                                    type: '绩效权重',
                                    count: item.weight,
                                }
                                newData.push(item1);
                                newData.push(item2);
                            }
                            setData(newData);
                            setIsRefresh(false);
                        } else {
                            messageApi.error(data.msg, CNF.messageDuration);
                        }
                    }
                })
            }
        }
    }, [props, isRefresh, messageApi, startDate, endDate]);

    useEffect(() => {
        const chart = new Chart({
            container: 'antv-g2-id',
            autoFit: true,
        });

        chart.title({
            title: '工单年度产品统计',
            subtitle: '展示年度内工单产品分类统计数量。',
        });

        chart.data(data);

        chart
            .interval()
            .encode('x', 'douser')
            .encode('y', 'count')
            .encode('color', 'type')
            .transform({ type: 'dodgeX' })
            .animate('enter', {
                type: 'scaleInY',
                duration: CNF.animateDuration,
            },)
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '处理人员', })
            .tooltip(false)
            .scrollbar('x', data.length > 50 ? true : false)
            .style('minWidth', 30)
            .style('maxWidth', 40);

        chart
            .encode('x', 'douser')
            .encode('y', 'count')
            .encode('color', 'type')
            .scale('y', {
                nice: true,
            })
            .axis('y', false)

        chart
            .line()
            .animate('enter', {
                type: 'pathIn',
                duration: CNF.animateDuration,
            },)
            .encode('shape', 'smooth')
            .style('lineWidth', 1)
            .tooltip({
                items: [(d => ({
                    name: `${d.type}`,
                    value: `${d.count}`,
                }))],
            });


        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props.collapsed, data]);

    return <>
        {contextHolder}
        <Row style={{ margin: '15px 0 0 15px' }}>
            <Col span={isGTscreenWidth ? 5 : 6}>
                <RangePicker
                    placeholder={['开始日期', '结束日期']}
                    locale={locale}
                    style={{ width: '100%' }}
                    format='YYYY-MM-DD'
                    onChange={(_, dateString) => {
                        setStartDate(dateString[0] ? dateString[0] : LastMonth() + '-01');
                        setEndDate(dateString[1] ? dateString[1] : LastMonth() + '-31');
                        setIsRefresh(true);
                    }}
                />
            </Col>
        </Row>
        <div id='antv-g2-id'></div>
    </>

}

export default WOWDCD;